import React from 'react';
import styles from './index.module.scss';

const ModuleTitle = (props: { mark?: string; title?: string; titleStyle?: any }) => {
  const { mark, title, titleStyle } = props;

  return (
    <div>
      {mark === 'large' && (
        <div
          className={styles.largeTitleStyle}
          style={titleStyle}>
          {title}
        </div>
      )}
      {mark === 'middle' && (
        <div
          className={styles.middleTitleStyle}
          style={titleStyle}>
          {title}
        </div>
      )}
    </div>
  );
};

export default ModuleTitle;
